/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestCreateNoticeRequest,
  RequestDeleteNoticeRequest,
  RequestGetNoticeRequest,
  RequestUpdateNoticeRequest,
  ResponseGetNoticeResponse,
} from '../models/index';
import {
    RequestCreateNoticeRequestFromJSON,
    RequestCreateNoticeRequestToJSON,
    RequestDeleteNoticeRequestFromJSON,
    RequestDeleteNoticeRequestToJSON,
    RequestGetNoticeRequestFromJSON,
    RequestGetNoticeRequestToJSON,
    RequestUpdateNoticeRequestFromJSON,
    RequestUpdateNoticeRequestToJSON,
    ResponseGetNoticeResponseFromJSON,
    ResponseGetNoticeResponseToJSON,
} from '../models/index';

export interface NoticeCreateNoticePostRequest {
    req: RequestCreateNoticeRequest;
}

export interface NoticeDeleteNoticePostRequest {
    req: RequestDeleteNoticeRequest;
}

export interface NoticeGetAllNoticePostRequest {
    req: RequestGetNoticeRequest;
}

export interface NoticeUpdateNoticePostRequest {
    req: RequestUpdateNoticeRequest;
}

/**
 * 
 */
export class NoticeApi extends runtime.BaseAPI {

    /**
     * お知らせ新規登録
     * お知らせ新規登録
     */
    async noticeCreateNoticePostRaw(requestParameters: NoticeCreateNoticePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetNoticeResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling noticeCreateNoticePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/notice/createNotice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCreateNoticeRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetNoticeResponseFromJSON));
    }

    /**
     * お知らせ新規登録
     * お知らせ新規登録
     */
    async noticeCreateNoticePost(requestParameters: NoticeCreateNoticePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetNoticeResponse>> {
        const response = await this.noticeCreateNoticePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * お知らせ削除
     * お知らせ削除
     */
    async noticeDeleteNoticePostRaw(requestParameters: NoticeDeleteNoticePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetNoticeResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling noticeDeleteNoticePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/notice/deleteNotice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestDeleteNoticeRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetNoticeResponseFromJSON));
    }

    /**
     * お知らせ削除
     * お知らせ削除
     */
    async noticeDeleteNoticePost(requestParameters: NoticeDeleteNoticePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetNoticeResponse>> {
        const response = await this.noticeDeleteNoticePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * お知らせ一覧を取得
     * お知らせ一覧を取得
     */
    async noticeGetAllNoticePostRaw(requestParameters: NoticeGetAllNoticePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetNoticeResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling noticeGetAllNoticePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/notice/getAllNotice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetNoticeRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetNoticeResponseFromJSON));
    }

    /**
     * お知らせ一覧を取得
     * お知らせ一覧を取得
     */
    async noticeGetAllNoticePost(requestParameters: NoticeGetAllNoticePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetNoticeResponse>> {
        const response = await this.noticeGetAllNoticePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * お知らせ更新
     * お知らせ更新
     */
    async noticeUpdateNoticePostRaw(requestParameters: NoticeUpdateNoticePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetNoticeResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling noticeUpdateNoticePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/notice/updateNotice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdateNoticeRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetNoticeResponseFromJSON));
    }

    /**
     * お知らせ更新
     * お知らせ更新
     */
    async noticeUpdateNoticePost(requestParameters: NoticeUpdateNoticePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetNoticeResponse>> {
        const response = await this.noticeUpdateNoticePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
